import PortalProps from '@/interfaces/portals';

import { get } from './api';

class PortalsService {
  public async list() {
    const response = await get<PortalProps[]>({
      url: 'learner/showcase/schools'
    });

    return response?.data;
  }
}

const portalsService = new PortalsService();
export default portalsService;
